import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import DeliveryContent from './DeliveryContent';
import './delivery-options.style.scss';
import { track } from '../analytics';
import { dataModel } from './dataModel';

const DeliveryOptions = ({
  storeId,
  zipCode,
  itemId,
  quantity,
  children,
  visible
}) => {

  const [linkClicked, setLinkClicked] = useState(visible);

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setLinkClicked(true);

    track('click', {
      origin: 'delivery-options',
      eventName: 'shipping options',
      primaryCategory: 'tooltip'
    });
  };

  return (
    <div className="delivery-options">
      <Tooltip
        channel="desktop"
        closeButton
        visible={visible}
        content={linkClicked ? (
          <DeliveryContent
            zipCode={zipCode}
            storeId={storeId}
            itemId={itemId}
            quantity={quantity}
          />
        ) : ('')}
        maxWidth={320}
        placement="bottom"
      >
        <button type="button" className="u__default-link" onClick={handleOnClick}>
          {children}
        </button>
      </Tooltip>
    </div>
  );
};

DeliveryOptions.displayName = 'DeliveryOptions';

DeliveryOptions.propTypes = {
  itemId: PropTypes.string.isRequired,
  storeId: PropTypes.string,
  zipCode: PropTypes.string,
  children: PropTypes.node,
  visible: PropTypes.bool,
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

DeliveryOptions.defaultProps = {
  children: 'Delivery Options',
  storeId: '',
  zipCode: '',
  quantity: 1,
  visible: false
};

DeliveryOptions.dataModel = dataModel;

export default DeliveryOptions;
